export function NotFound() {
  const el = document.createElement('div')
  el.className = 'page-notfound container'
  el.innerHTML = `
    <p class="notfound-code">404</p>
    <h1>Page not found</h1>
    <p>The page you're looking for doesn't exist.</p>
    <a href="#/" class="btn-primary">Back to home</a>
  `
  return el
}
